import { environment } from '../environments/environment';

/** Registro de remotos del shell (name del MF → URL de remoteEntry.json). */
export const shellFederationRemotes: Record<string, string> = {
  'suite-mf-bms': environment.suiteMfBmsRemoteEntry,
  // Solo `environment.local.ts` apunta a un remoto real (localhost:4215); el
  // resto declara la clave vacia hasta que suite-mf-for se despliegue.
  'suite-mf-for': environment.suiteMfForRemoteEntry,
  'suite-mf-aap': environment.suiteMfAapRemoteEntry,
  'suite-mf-mcf': environment.suiteMfMcfRemoteEntry,
  'suite-mf-dfk': environment.suiteMfDfkRemoteEntry,
  'suite-mf-vpc': environment.suiteMfVpcRemoteEntry,
};
